/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardMasterCard/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCardMasterCard({
  children,
  viewPath = "/DesignSystem/Svgs/CreditCardMasterCard",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 55,
  height = 35,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#fff",
  fill3 = "#f26223",
  fill4 = "#e82128",
  fill5 = "#f69e1f"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CreditCardMasterCard.Svg"
  data-view-path={viewPath}
 viewBox="0 0 55 35"
 fillRule="evenodd"
 clipRule="evenodd"
 strokeLinejoin="round"
 strokeMiterlimit={2}
 style={{'--as-1-Z2bywIG': alignSelf,'--mt-2-Z2bywIG': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z2bywIG': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z2bywIG': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z2bywIG': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z2bywIG': opacity,'--w-10-Z2bywIG': typeof width === 'number' ? `${width}px` : width,'--h-11-Z2bywIG': typeof height === 'number' ? `${height}px` : height,'--a-7-Z2bywIG': isAnimated ? animation : "none",'--sd-8-Z2bywIG': isAnimated ? strokeDashoffset : 0,'--sd-9-Z2bywIG': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CreditCardMasterCard.SvgPath"
  data-view-path={viewPath}
 d="M-74.3-20.8h288v74h-288z"
 style={{'--f-12-Z2bywIG': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="CreditCardMasterCard.SvgPath:1"
  data-view-path={viewPath}
 d="M0 0h54.6v34.6H0z"
 className="views-block"
/>
<path
  data-testid="CreditCardMasterCard.SvgPath:2"
  data-view-path={viewPath}
 d="M15.2 31.7v-2c0-.7-.4-1.2-1.2-1.2-.4 0-.8.1-1.1.6-.2-.3-.6-.6-1-.6-.3 0-.7.1-.9.5v-.4h-.6v3.1h.6v-1.8c0-.5.3-.8.8-.8.4 0 .7.3.7.8v1.8h.6v-1.8c0-.5.3-.8.8-.8s.7.3.7.8v1.8h.6zm10.1-3.1h-1.1v-.9h-.6v.9h-.7v.6h.7v1.5c0 .7.3 1.2 1.1 1.2.3 0 .6-.1.8-.2l-.2-.6c-.2.1-.4.2-.6.2-.3 0-.5-.2-.5-.5v-1.5h1.1v-.7zm5.8-.1c-.4 0-.7.2-.8.5v-.4h-.6v3.1h.6V30c0-.5.2-.8.7-.8.1 0 .3 0 .4.1l.2-.6c-.2-.2-.4-.2-.5-.2zm-8.7.3c-.3-.2-.8-.3-1.3-.3-.8 0-1.3.4-1.3 1 0 .5.4.8 1 .9h.3c.4.1.6.2.6.4s-.3.4-.7.4c-.5 0-.8-.1-1-.3l-.3.4c.5.3 1 .4 1.3.4.9 0 1.4-.4 1.4-1 0-.5-.4-.8-1.1-.9H21c-.3 0-.6-.1-.6-.3 0-.2.2-.4.6-.4.4 0 .8.1 1 .3l.4-.6zm9.4 1.3c0 .9.6 1.6 1.6 1.6.5 0 .8-.1 1.1-.4l-.3-.5c-.3.2-.5.3-.8.3-.5 0-1-.4-1-1.1 0-.7.4-1 1-1.1.3 0 .6.1.8.3l.3-.5c-.3-.3-.6-.4-1.1-.4-1 .2-1.6.9-1.6 1.8zm-4.4-1.6c-.9 0-1.5.7-1.5 1.6 0 1 .7 1.6 1.6 1.6.5 0 .9-.1 1.3-.4l-.3-.5c-.3.2-.6.3-.9.3-.4 0-.9-.2-1-.8h2.3V30c0-.9-.6-1.5-1.5-1.5zm0 .6c.5 0 .8.3.8.8h-1.7c.1-.5.4-.8.9-.8zM19 31.5v-3h-.6v.4c-.2-.3-.6-.5-1-.5-.9 0-1.5.7-1.5 1.6 0 .9.7 1.6 1.5 1.6.4 0 .8-.2 1-.5v.4h.6zm-2.5-1.4c0-.6.4-1.1 1-1.1s.9.4.9 1.1c0 .6-.4 1.1-.9 1.1-.6 0-1-.5-1-1.1zm24-1.6c-.4 0-.7.2-.8.5v-.4h-.6v3.1h.6V30c0-.5.2-.8.7-.8.1 0 .3 0 .4.1l.2-.6c-.2-.2-.4-.2-.5-.2zm-2.4 3v-3h-.6v.4c-.2-.3-.6-.5-1-.5-.9 0-1.5.7-1.5 1.6 0 .9.7 1.6 1.5 1.6.4 0 .8-.2 1-.5v.4h.6zm-2.5-1.4c0-.6.4-1.1 1-1.1s.9.4.9 1.1c0 .7-.4 1.1-.9 1.1-.7 0-1-.5-1-1.1zm8.8 1.4v-4.2h-.6v1.6c-.2-.3-.6-.5-1-.5-.9 0-1.5.7-1.5 1.6 0 .9.7 1.6 1.5 1.6.4 0 .8-.2 1-.5v.4h.6zm-2.6-1.4c0-.6.4-1.1 1-1.1s.9.4.9 1.1c0 .6-.4 1.1-.9 1.1-.6 0-1-.5-1-1.1z"
 fillRule="nonzero"
 style={{'--f-12-Z2bywIG': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
<path
  data-testid="CreditCardMasterCard.SvgPath:3"
  data-view-path={viewPath}
 d="M21.7 4.9h11.2v18.4H21.7z"
 style={{'--f-12-Z2bywIG': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="CreditCardMasterCard.SvgPath:4"
  data-view-path={viewPath}
 d="M22.8 14.1c0-3.7 1.7-7 4.5-9.2-2-1.6-4.5-2.5-7.2-2.5-6.5 0-11.7 5.2-11.7 11.7 0 6.5 5.2 11.7 11.7 11.7 2.7 0 5.2-.9 7.2-2.5-2.7-2.2-4.5-5.5-4.5-9.2z"
 fillRule="nonzero"
 style={{'--f-12-Z2bywIG': fill4}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="CreditCardMasterCard.SvgPath:5"
  data-view-path={viewPath}
 d="M46.2 14.1c0 6.5-5.2 11.7-11.7 11.7-2.7 0-5.2-.9-7.2-2.5 2.7-2.1 4.5-5.5 4.5-9.2 0-3.7-1.7-7-4.5-9.2 2-1.6 4.5-2.5 7.2-2.5 6.5 0 11.7 5.2 11.7 11.7z"
 fillRule="nonzero"
 style={{'--f-12-Z2bywIG': fill5}}
 className={`views-block ${styles.SvgPath4}`}
/>
<g
  data-testid="CreditCardMasterCard.SvgGroup"
  data-view-path={viewPath}
 className="views-block"
>
<path
  data-testid="CreditCardMasterCard.SvgPath:6"
  data-view-path={viewPath}
 d="M44.8 21l.4-.1v.1H45v.4h-.1V21h-.1zm.6-.1l.1.3.1-.3h.1v.5-.4l-.1.4h-.1l-.1-.5v.5h-.1v-.5h.1z"
 fillRule="nonzero"
 style={{'--f-12-Z2bywIG': fill5}}
 className={`views-block ${styles.SvgPath5}`}
/>
</g>
<g
  data-testid="CreditCardMasterCard.SvgGroup:1"
  data-view-path={viewPath}
 className="views-block"
>
<path
  data-testid="CreditCardMasterCard.SvgPath:7"
  data-view-path={viewPath}
 d="M45.7 31.7c-.1.1-.1.1-.2.1s-.2 0-.2-.1c-.1-.1-.1-.1-.1-.2s0-.2.1-.2c.1-.1.1-.1.2-.1s.2 0 .2.1c.1.1.1.1.1.2s0 .2-.1.2zm-.4-.4c-.1.1-.1.1-.1.2s0 .1.1.2.1.1.2.1.1 0 .2-.1.1-.1.1-.2 0-.1-.1-.2-.1-.1-.2-.1c-.1.1-.1.1-.2.1zm.2.1s.1 0 0 0c.1 0 .1.1.1.1v.1h.1v.1h-.1v-.1h-.1v.1h-.1v-.3h.1zm.1 0s-.1 0 0 0h-.1v.1h.2c-.1 0-.1-.1-.1-.1z"
 fillRule="nonzero"
 style={{'--f-12-Z2bywIG': fill}}
 className={`views-block ${styles.SvgPath6}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}